import homepage from '@/assets/tutorials/home.png'
import homepageDev from '@/assets/tutorials/home-dev.png'
import homepageDashboard from '@/assets/tutorials/home-dashboard.png'
import homepageWorkspaces from '@/assets/tutorials/home-workspaces.png'

// templates
import templatesSearch from '@/assets/tutorials/templates-search.png'
import templatesSelected from '@/assets/tutorials/templates-selected.png'
import templatesAvailable from '@/assets/tutorials/templates-available.png'

// dashboard
import dashboardSidebar from '@/assets/tutorials/dashboard-sidebar.png'
import dashboardMenu from '@/assets/tutorials/dashboard-menu.png'
import footerInfoCenter from '@/assets/tutorials/footer-infocenter.png'

// dev
import devYellow from '@/assets/tutorials/dev-yellowtrack.png'
import devDevelopers from '@/assets/tutorials/dev-developers.png'
import devCreate from '@/assets/tutorials/dev-create.png'

export const seeMore = {
    'tutorials.seeMore.introduction': 'introduction',
    'tutorials.seeMore.templates': 'templates',
    'tutorials.seeMore.dashboard': 'dashboard',
    'tutorials.seeMore.dev': 'dev'
}

export default {
    introduction: [
        {
            text: 'tutorials.introduction.homepage',
            img: homepage,
        },
        {
            text: 'tutorials.introduction.homepageDev',
            img: homepageDev,
        },
        {
            text: 'tutorials.introduction.homepageDashboard',
            img: homepageDashboard
        },
        {
            text: 'tutorials.introduction.homepageWorkspaces',
            img: homepageWorkspaces
        },
    ],

    templates: [
        {
            text: 'tutorials.templates.list'
        },
        {
            text: 'tutorials.templates.search',
            img: templatesSearch
        },
        {
            text: 'tutorials.templates.inspect',
            img: templatesSelected
        },
        {
            text: 'tutorials.templates.available',
            img: templatesAvailable
        }
    ],

    dashboard: [
        {
            text: 'tutorials.dashboard.welcome'
        },
        {
            text: 'tutorials.dashboard.sidebar',
            img: dashboardSidebar
        },
        {
            text: 'tutorials.dashboard.menu',
            img: dashboardMenu
        },
        {
            text: 'tutorials.dashboard.infoCenter',
            img: footerInfoCenter
        }
    ],

    dev: [
        {
            text: 'tutorials.dev.welcome'
        },
        {
            text: 'tutorials.dev.yellow',
            img: devYellow
        },
        {
            text: 'tutorials.dev.developers',
            img: devDevelopers
        },
        {
            text: 'tutorials.dev.create',
            img: devCreate
        }
    ]

}